var cov_20l6hjj7ak = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/mode.tsx",
      hash = "b30760ee334fe200318413adfa2f9084d418411b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/mode.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 19
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 10,
          column: 4
        }
      },
      "2": {
        start: {
          line: 7,
          column: 18
        },
        end: {
          line: 7,
          column: 41
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 41
        }
      },
      "4": {
        start: {
          line: 8,
          column: 23
        },
        end: {
          line: 8,
          column: 41
        }
      },
      "5": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 42
        }
      },
      "6": {
        start: {
          line: 13,
          column: 38
        },
        end: {
          line: 13,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 27
          },
          end: {
            line: 5,
            column: 28
          }
        },
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 10,
            column: 4
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 29
          },
          end: {
            line: 6,
            column: 30
          }
        },
        loc: {
          start: {
            line: 6,
            column: 55
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 13,
            column: 16
          }
        },
        loc: {
          start: {
            line: 13,
            column: 38
          },
          end: {
            line: 13,
            column: 58
          }
        },
        line: 13
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 41
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 8,
            column: 41
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 9,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 21
          },
          end: {
            line: 9,
            column: 35
          }
        }, {
          start: {
            line: 9,
            column: 38
          },
          end: {
            line: 9,
            column: 42
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { formConsumer } from './formContext';
import { memoize } from '../utils/func';
var createMode = (cov_20l6hjj7ak.s[0]++, memoize(function (mode) {
  cov_20l6hjj7ak.f[0]++;
  cov_20l6hjj7ak.s[1]++;
  return formConsumer(['formMode'], function (props) {
    cov_20l6hjj7ak.f[1]++;
    var isMatch = (cov_20l6hjj7ak.s[2]++, mode === props.formMode);
    cov_20l6hjj7ak.s[3]++;

    if (props.reverse) {
      cov_20l6hjj7ak.b[0][0]++;
      cov_20l6hjj7ak.s[4]++;
      isMatch = !isMatch;
    } else {
      cov_20l6hjj7ak.b[0][1]++;
    }

    cov_20l6hjj7ak.s[5]++;
    return isMatch ? (cov_20l6hjj7ak.b[1][0]++, props.children) : (cov_20l6hjj7ak.b[1][1]++, true);
  });
}));
export default (function () {
  cov_20l6hjj7ak.f[2]++;
  cov_20l6hjj7ak.s[6]++;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(createMode);
});